<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VTextareaWithLabel from "../../Form/Survey/VTextareaWithLabel.vue";

import { useForm } from "@inertiajs/vue3";

const props = defineProps({
    additional: Object,
    isShowSubmit: {
        Type: Boolean,
        default: true,
    },
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    feedbacks: answers?.feedbacks,
});

const emits = defineEmits("onNext");

const handleClickNext = () => {
    emits("onNext", form.data());
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <VTextareaWithLabel
                        elId="feedbacks"
                        v-model:value="form.feedbacks"
                        :label="surveyFields['feedbacks']?.name"
                    />
                </div>
            </div>
        </div>

        <VDevider />
        <div class="text-end" v-if="isShowSubmit">
            <VButtonSubmit type="button" @onCLickSubmit="handleClickNext">
                Next
            </VButtonSubmit>
        </div>
    </div>
</template>
